import { createIconComponent } from '../../factory/create-icon-component';
export const LinkIcon = createIconComponent(
  'LinkIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 5H15C16.3197 5 17.554 5.36518 18.6076 6M14.5 19H15C18.866 19 22 15.866 22 12C22 10.9264 21.7583 9.90926 21.3264 9M9.5 19H9C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5H9.5M8 12H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
